<!DOCTYPE HTML>
<html>

<head>
</head>

<body class="footer bg-black">
    <div class="footer bg-black" role="contentinfo">
        <div class="container h-100 pt-0">
            <div class="h-100 mt-auto">
                <div class="my-auto col-12 pb-0">
                    <div class="row h-100 mt-5 pt-4">
                        <div class="col-3 offset-md-3 pb-4">
                            <img src="images/deloitte.svg" alt="Deloitte" class="splash__logo mb-1" />
                        </div>
                        <div class="col-3 text-align-end mt-3">
                            @if (usersName) {
                            <div class="text-white small mb-2 float-right mt-1">
                                <small>
                                    Welcome {{usersName}}| <a (click)="signOutClicked()">
                                        <strong class="pointer">
                                            Sign
                                            out
                                        </strong>
                                    </a>
                                </small>
                            </div>
                            }
                        </div>
                        <div class="col-md-6 offset-md-3">
                            <div class="card">
                                <div class="card-header no-rounded bg-info">
                                    <p class="h5 m-0 text-white">
                                        Available Portals
                                    </p>
                                </div>
                                <div class="card-block no-rounded p-0">
                                    <ul class="list-group">
                                        @for (businessFunction of businessFunctions; track businessFunction) {
                                        <li class="list-group-item list-group-action justify-content-between no-rounded border-left-0 border-right-0">
                                            <div>
                                                {{businessFunction.displayName}}
                                            </div>
                                            <div class="col text-right">
                                                @if (!businessFunction.disabled) {
                                                <button class="btn btn-outline-info btn-sm"
                                                        (click)="editClicked(businessFunction)">
                                                    Select
                                                </button>
                                                }
                                                @if (businessFunction.disabled) {
                                                <span class="text-danger">
                                                    Decommissioned
                                                </span>
                                                }
                                            </div>
                                        </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 offset-md-3 pt-sm-1 ">
                            <p class="text-white small">
                                Your use of this portal is subject to
                                <a href="/generictermsofuse"> Terms of Use.</a>
                                If you would no longer like to have access to this portal, please
                                <a href="mailto:gtls@deloitte.com">Contact us</a>
                            </p>
                        </div>
                        <div>
                            <p class="text-muted small mt-4">
                                Deloitte refers to one or more of Deloitte Touche Tohmatsu Limited (&#8220;DTTL&#8220;),
                                its global network of member firms, and their related entities (collectively,
                                the &#8220;Deloitte organization&#8220;). DTTL (also referred to as &#8220;Deloitte
                                Global&#8220;)
                                and each of its member firms and related entities are legally separate and independent
                                entities,
                                which cannot obligate or bind each other in respect of third parties.
                                DTTL and each DTTL member firm and related entity is liable only for its own acts and
                                omissions,
                                and not those of each other. DTTL does not provide services to clients. Please see
                                <a href="https://www2.deloitte.com/uk/en/legal/about-deloitte.html"
                                   target="_blank">About Deloitte</a> to learn more.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>

</html>